var _a, _b;
import { __decorate, __metadata, __param } from "tslib";
import { inject, injectable } from 'inversify';
import { CustomFieldsModel } from '../models/custom-fields-model.interface';
import { SaveCustomFieldAsPublicRepository } from '../repositories/save-custom-field-as-public-repository.interface';
let SaveCustomFieldAsPublicServiceImpl = class SaveCustomFieldAsPublicServiceImpl {
    constructor(_customFieldsModel, _saveCustomFieldAsPublicRepository) {
        this._customFieldsModel = _customFieldsModel;
        this._saveCustomFieldAsPublicRepository = _saveCustomFieldAsPublicRepository;
    }
    async saveAsCompanyCustomField(customFields) {
        await this._saveAs(customFields);
        this._updateCounts(customFields);
        return;
    }
    _updateCounts(customFields) {
        this._customFieldsModel.update(model => {
            model.counts = {
                customFieldCount: model.counts.customFieldCount,
                publicCustomFieldCount: model.counts.publicCustomFieldCount + customFields.length,
            };
            return model;
        });
    }
    _saveAs(customFields) {
        return this._saveCustomFieldAsPublicRepository.saveAsCompanyCustomField(customFields);
    }
};
SaveCustomFieldAsPublicServiceImpl = __decorate([
    injectable(),
    __param(0, inject(CustomFieldsModel)),
    __param(1, inject(SaveCustomFieldAsPublicRepository)),
    __metadata("design:paramtypes", [typeof (_a = typeof CustomFieldsModel !== "undefined" && CustomFieldsModel) === "function" ? _a : Object, typeof (_b = typeof SaveCustomFieldAsPublicRepository !== "undefined" && SaveCustomFieldAsPublicRepository) === "function" ? _b : Object])
], SaveCustomFieldAsPublicServiceImpl);
export { SaveCustomFieldAsPublicServiceImpl };
